export function splitWords(text: string, length: number): string[] {
    if (!text) {
        return
    }

    let index = 0
    const resultString = ['']

    text.split(' ').map(word => {
        const phrase = resultString[index] + word

        if (phrase.length < length) {
            resultString[index] += word + ' '
        } else {
            resultString[index] = resultString[index].trim()
            index += 1
            resultString.push(word + ' ')
        }
    })

    resultString[index] = resultString[index].trim()

    return resultString
}
